/* eslint-disable @typescript-eslint/no-empty-function */
import { Link } from 'react-router-dom-6';

import styles from './Vaccinations.module.less';

import { Alert, Button, DescriptionsCollapse, Divider } from '$HVUI';
import { useBeacon } from '$Hooks';
import { flexibleDateString, fullNameFromProfile } from '$Utils';

const beaconID = 'ea8e4d3a-dcc4-4b1d-bda0-16afbc8a708f';

const VaccinationDetail = props => {
    const {
        vaccination: {
            administration_route,
            get_display_location: location,
            id,
            is_image_upload_accepted: accepted,
            is_user_submitted: userSubmitted,
            vaccination_administration_datetime,
            vaccination_lot_number,
            vaccine: { condition_slug, is_booster, short_name },
            vaccine_dose: { dose_sequence_number, dose_volume }
        },
        me,
        firstDoseID,
        isLoggedIn,
        index
    } = props;

    useBeacon(beaconID, { autoInit: false });
    const showBeacon = () => {
        window.Beacon?.('init', beaconID);
        window.Beacon?.('identify', {
            name: fullNameFromProfile(me),
            email: me.email
        });
        window.Beacon?.('prefill', {
            subject: 'Vaccination Upload Issue'
        });
        window.Beacon?.('open');
    };

    const failed = userSubmitted && accepted === false;
    const processing = userSubmitted && accepted === null;

    const administrationDate = flexibleDateString(
        vaccination_administration_datetime,
        null,
        'MES'
    );
    let lotNumber = vaccination_lot_number;
    if (typeof lotNumber === 'string') {
        lotNumber = lotNumber.replace('lot_', '');
    }

    const detailRows = [
        (is_booster || dose_sequence_number) && [
            'Dose #:',
            is_booster ? index + 1 : dose_sequence_number
        ],
        short_name && ['Vaccine Type:', short_name],
        administrationDate && ['Date Administered:', administrationDate],
        condition_slug !== 'covid19' &&
            dose_volume && ['Dose Amount:', dose_volume],
        administration_route && ['Administered Site:', administration_route],
        location && ['Healthcare or Clinic:', location],
        lotNumber && ['Lot #:', lotNumber]
    ];

    if (processing) {
        return (
            <div className={styles['print-hide']}>
                <Divider className={styles['divider-card']} />
                <Alert
                    message="Thank you for uploading your vaccination record. It will show up here once your image finishes processing in a few minutes."
                    type="info"
                    key={`${id}-processing`}
                    showIcon
                />
            </div>
        );
    }
    if (failed) {
        const imageUploadPath = secondDoseID => {
            if (!firstDoseID) {
                console.error('Could not find first dose');
            }
            //don't pass image ID, we want to force a new upload
            return `/vaccination-upload/single_dose/${firstDoseID}/${secondDoseID}/0/0/agreement`;
        };
        return (
            <div className={styles['print-hide']}>
                <Divider className={styles['divider-card']} />
                <Alert
                    message={
                        <>
                            The vaccination record(s) you provided failed our
                            verification process. Please
                            {isLoggedIn && <> try your upload again, or </>}
                            <button
                                style={{
                                    display: 'inline',
                                    background: 'none',
                                    border: 'none'
                                }}
                                onClick={showBeacon}
                            >
                                contact our support team by clicking here
                            </button>
                            .
                            <br />
                            {isLoggedIn && (
                                <Link
                                    id="retry-upload"
                                    key="upload-dose"
                                    to={imageUploadPath(id)}
                                    style={{
                                        display: 'block',
                                        textAlign: 'center'
                                    }}
                                >
                                    <Button
                                        style={{ marginTop: '16px' }}
                                        // Don't need onClick, we're in a Link
                                        onClick={() => {}}
                                        id="upload-vaccination"
                                        level="primary"
                                        size="narrow"
                                        text="Upload 2nd dose"
                                    />
                                </Link>
                            )}
                        </>
                    }
                    type="error"
                    key={`${id}-error`}
                />
            </div>
        );
    }

    return (
        <>
            <Divider className={styles['divider-card']} />
            <DescriptionsCollapse
                key={`${id}-descriptions`}
                collapsedRowCount={3}
                rows={detailRows}
            />
        </>
    );
};

export default VaccinationDetail;
